import React from 'react';
import {
  AppLayout,
  Header,
  SideNavigation,
  Container,
  ContentLayout,
  Cards,
  Box,
  SpaceBetween,
  Link,
  Button,
} from '@cloudscape-design/components';
import { applyMode, applyDensity, Density, Mode } from '@cloudscape-design/global-styles';
import MeetingsPage from './MeetingsPage';
import GetStarted from './GetStartedPage';
import { useLocation } from 'react-router-dom';
import '../containers.css';
import TopNavigation  from './GlobalHeader';
import { useAuth } from './AuthContext';
import { NavigationSide  } from './Navigation';

applyMode(Mode.Dark);

function MyAppLayout() {
  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();
    
    if (!isAuthenticated) {
      return <div>You need to be authenticated to view this page.</div>;
    }
  
    console.log(isAuthenticated);
  return (
    
    <AppLayout
      navigation={<NavigationSide activeHref={location.pathname} />}
      content={
        isAuthenticated ? (
          
            <>
            <MainContent />
            </>
                      
          ) : (
            <Button onClick={logout}>Logout</Button>
          )}
      contentType="dashboard"
      toolsHide={true}
    />
  );
}
function Navigation() {
  return (
    <SideNavigation
      header={{ text: 'AWS Eloquence', href: '/' }}
      items={[
        { type: 'link', text: 'Learn More', href: '/learnmore' },
        { type: 'link', text: 'Get Started', href: '/getstarted' },
        { type: 'link', text: 'My Meetings', href: '/meetings' },
        { type: 'link', text: 'Meet the Team', href: '/meettheteam' },
        { type: 'link', text: 'Architecture Diagram', href: '/architecture'},
        { type: 'divider' },
        { type: 'link', text: 'Documentation', href: '/documentation' },
      ]}
    />
  );
}

function MainContent() {
  return (
    <>
    <ContentLayout
    defaultPadding
    headerVariant="high-contrast"
    disableOverlap
    header={
      <Header
        variant="h1"
        description="AI-powered Conversation Coach"
      >
        AWS Eloquence
      </Header>
    }
  >

      <ContentLayout
        defaultPadding
        disableOverlap
      >
        <br></br>

          <SpaceBetween size="l">
            <Cards
              cardDefinition={{
                header: item => (
                  <Header variant="h2">{item.name}</Header>
                ),
                sections: [
                  {
                    id: "description",
                    content: (item) => item.description,
                  },
                  {
                    id: "link",
                    content: item => (
                      <Link href={item.href}>{item.name}</Link>
                    )
                  }
                ]
              }}
              cardsPerRow={[
                { cards: 1 },
                { minWidth: 500, cards: 2 }
              ]}
              items={[
                {
                  name: "Learn More",
                  description: "Learn the basics of AWS Eloquence",
                  href: "/learnmore",
                  // className: "glowing-container-purple"
                },
                {
                  name: "Get Started",
                  description: "Download the Eloquence Chrome Extension",
                  href: "/getstarted",
                  // className: "glowing-container-purple"
                },
                {
                  name: "My Meetings",
                  description: "Access previous Eloquence meetings and metrics",
                  href: "/meetings",
                  // className: "glowing-container-purple"
                },
                {
                  name: "Documentation",
                  description: "Read our PRFAQ and Narrative",
                  href: "/documentation",
                  // className: "glowing-container-purple"
                },
                {
                  name: "Meet the Team",
                  description: "Meet the team behind Eloquence",
                  href: "/meettheteam",
                  // className: "glowing-container-purple"
                },
                {
                  name: "Architecture Diagram",
                  description: "View the Eloquence Architecture Diagram",
                  href: "/architecture",
                  // className: "glowing-container-purple"
                }

              ]}
            />
          </SpaceBetween>
      </ContentLayout>
    </ContentLayout>
    </>
  );
}

function PageHeader() {
  return (
    <Header
      variant="h1"
      actions={
        <div>
          {/* Add any header actions here */}
        </div>
      }
    >
      My Application
    </Header>
  );
}
export default MyAppLayout;










